import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

// Requires any logged-in user
export function RequireAuth({ children }) {
  const { session, loading } = useAuth()

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-text-muted)' }}>
      Loading…
    </div>
  )

  if (!session) return <Navigate to="/login" replace />
  return children
}

// Requires admin role from public.users
export function RequireAdmin({ children }) {
  const { session, user, loading, profileError, effectiveRole } = useAuth()

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-text-muted)' }}>
      Loading…
    </div>
  )

  if (!session) return <Navigate to="/login" replace />

  if (profileError || !user) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-text-muted)', padding: 24, textAlign: 'center' }}>
      {profileError || 'Could not load your profile from public.users.'}
    </div>
  )

  if (effectiveRole !== 'admin') return <Navigate to="/my-jobs" replace />
  return children
}
